import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type CardVariant = 'default' | 'sage-soft' | 'peach-soft';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
}

const variantClass: Record<CardVariant, string> = {
  default: 'bg-background border border-border',
  'sage-soft': 'surface-sage-soft border border-border',
  'peach-soft': 'surface-peach-soft border border-border'
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', ...props }, ref) => (
    <div
      ref={ref}
      className={cn('rounded-lg p-6 text-foreground', variantClass[variant], className)}
      {...props}
    />
  )
);
Card.displayName = 'Card';
